import {
  IBoardRankingEntry,
  IBoardRankingGroup,
} from '../../../dtos/IBoardSnapshot';

export interface IPodium {
  group: IBoardRankingGroup;
  /** Até 3 posições (empate divide a posição, então pode haver mais nomes). */
  places: IBoardRankingEntry[];
}

/** Linhas da tabela que o pódio ocupa na coluna (título + 3 colocações). */
export const PODIUM_ROWS = 4;

/**
 * Pódio de cada grupo na tela final (FE-77): 1º, 2º e 3º lugares, sem
 * desclassificadas e sem quem não pontuou. Grupo sem ninguém pontuando fica
 * de fora.
 */
export function podiums(groups: IBoardRankingGroup[]): IPodium[] {
  return groups
    .map(group => ({
      group,
      places: group.entries.filter(
        entry =>
          !entry.disqualified &&
          entry.position !== null &&
          entry.position <= 3 &&
          entry.points > 0,
      ),
    }))
    .filter(podium => podium.places.length > 0);
}
